
import {Component, Prop, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";

@Component({})
export default class MessageBox extends Vue {

  @Prop({required: true})
  user!: string

  @Prop({required: true})
  value!: string;

  @Prop({required: false})
  date: Date | undefined;

  formatDate(date: Date | undefined): string {
    if (!date) return "-";

    return `${DateTime.fromJSDate(date).toFormat("dd.MM.yyyy - HH:mm")} Uhr`;
  }
}
